export const getDealsPerPage = (): number => {
  if (
    typeof window !== 'undefined' &&
    window.matchMedia('only screen and (max-width: 800px)').matches
  )
    return 2;
  return 4;
};
